<template>
  <div>
    <div class="page_title">
      <custom-breadcrumb :suffix="`BatchOrder # ${this.dataInfo.batchInfoDetail.uid}`" :dsOrder="dsOrder"/>
      <!-- <el-button @click="handleViewInvoice" class="tracking-btn">View Invoice</el-button> -->
    </div>
    <div class="order">
      <el-card shadow="none">
        <div class="order-header">
          <div class="order-header-item">
            <span class="gray">Order Total</span>
            <span v-if="dataInfo.batchInfoDetail.payAmount">${{ dataInfo.batchInfoDetail.payAmount }}</span>
          </div>
          <div class="border"/>
          <div class="order-header-item">
            <span class="gray">Order Date</span>
            <span>{{ dataInfo.batchInfoDetail.dateStr }}</span>
          </div>
          <div class="border"/>
          <div class="order-header-item">
            <span class="gray">Order Status</span>
            <span>{{ dataInfo.batchInfoDetail.batchStatusEnName }}</span>
          </div>
          <div class="border"/>
          <div class="order-header-item address">
            <!--              <span @click="openAddress">-->
            <!--                    Ship To-->
            <!--                <img src="@/assets/img/memo.png" alt="">-->
            <!--              </span>-->

            <span>{{ dataInfo.batchInfoDetail.name }} {{ dataInfo.batchInfoDetail.lastname }}</span>
            <span>{{ dataInfo.batchInfoDetail.address }}</span>
            <span>{{ dataInfo.batchInfoDetail.city }}, {{
                dataInfo.batchInfoDetail.province
              }}, {{ dataInfo.batchInfoDetail.countryName }}&nbsp;&nbsp;{{ dataInfo.batchInfoDetail.postCode }}</span>
            <span> {{ dataInfo.batchInfoDetail.areaCode }}{{ dataInfo.batchInfoDetail.phone }}</span>
          </div>
          <div class="border"/>
          <div class="order-header-item">
            <span class="gray">Customer</span>
            <span>{{ dataInfo.batchInfoDetail.name + ' ' + dataInfo.batchInfoDetail.lastname }}</span>
          </div>
        </div>
      </el-card>
      <el-card shadow="none" style="margin-top: 20px" class="order-content"
               v-for="brand in  dataInfo.batchInfoOrderList" :key="brand.id">

        <div class="order-content-header" slot="header">
          <span class="bold">{{ brand.tsStoreOrderInfo.brandName }}</span>
          <!--          <span>-->
          <!--            <el-button @click="handleTrackingInfo" class="tracking-btn">Tracking Info</el-button>-->
          <!--            Order {{ brand.tsStoreOrderInfo.uid }}-->
          <!--          </span>-->
        </div>
        <div class="order-content-item" v-for="(item,index) in brand.orderDetailList" :key="index">
          <el-image :src="item.skuImg" class="img" fit="fill"/>
          <div class="item-con">
            <span class="bold">{{ item.skuName }}</span>
            <span style="padding-top: 4px"> {{ item.skuParams }}<span style="color: #999999;margin-left:20px ">{{ item.vdSku }}</span></span>
            <div class="item-bottom">
              <div class="item-bottom-item">
                <span>Items</span>
                <span>{{ item.qty }}</span>
              </div>
              <div class="item-bottom-item">
                <span>Wholesale Price</span>
                <span>${{ Number(item.price).toFixed(2) }}</span>
              </div>
              <div class="item-bottom-item">
                <span>Total</span>
                <span>${{ Number(item.total).toFixed(2) }}</span>
              </div>
              <div class="item-bottom-item">
                <span>Status</span>
                <span>{{ $tool.valueToLabel(item.orderStatus, orderStatusOptions) }}</span>
              </div>
            </div>
          </div>
        </div>
      </el-card>
      <div class="order-bottom">
        <div>
          <span class="bold">Payment method</span>
          <span>{{ dataInfo.batchInfoDetail.paymethodEnName }}</span>
        </div>
        <div class="bottom-right">
          <span class="bold">Order Summary</span>
          <div v-for="(order,index) in dataInfo.batchInfoOrderList" :key="index" class="bottom-right-block">
            <div class="item">
              <span>{{ order.tsStoreOrderInfo.brandName }}</span>
              <span>${{ order.tsStoreOrderInfo.totalPrice || 0 }}</span>
            </div>
            <div class="item orange"
                 v-if="order.tsStoreOrderInfo.orderDiscounted && order.tsStoreOrderInfo.orderDiscounted>0">
              <span>{{ order.tsStoreOrderInfo.brandName }} Discount</span>
              <span>
                -${{ order.tsStoreOrderInfo.orderDiscounted }}
              </span>
            </div>
          </div>
          <el-divider/>
          <div class="item bold" style="margin-top: 5px">
            <span>Subtotal</span>
            <span>${{ Number(orderTotal['subTotal']).toFixed(2) }}</span>
          </div>
          <div class="bottom-right-block">
            <div class="item">
              <span>Shipping</span>
              <span>${{ Number(orderTotal['shipping']).toFixed(2) }}</span>
            </div>
            <div class="item orange" v-if="orderTotal['shippingDisc'] && Number(orderTotal['shippingDisc']) > 0">
              <span>Shipping Discount(By Brand)</span>
              <span>-${{ Number(orderTotal['shippingDisc']).toFixed(2) }}</span>
            </div>
          </div>
          <el-divider/>
          <div class="item bold " style="margin-top: 5px">
            <span>Order Total</span>
            <span>${{ Number(dataInfo['batchInfoDetail']['payAmount']).toFixed(2) }}</span>
          </div>
        </div>
      </div>
    </div>
    <Address ref="address" :address-message="addressMessage" type="ordeDetail"/>

    <!--图片预览-->
    <div class="images" v-viewer="{movable: false}">
      <img v-for="src in images" :src="src" :key="src">
    </div>
  </div>
</template>

<script>
import {getAction} from '@/api/manage.js'

import CustomBreadcrumb from '../components/custom-breadcrumb'
import Address from '../components/address'
import {directive as viewer} from 'v-viewer'

export default {
  components: {CustomBreadcrumb, Address},
  directives: {
    viewer: viewer({
      debug: false
    })
  },
  data() {
    return {
      dsOrder: '',
      isDropShipping: false,
      userId: this.$ls.get('userInfo').id,
      images: [],
      batchNo: '',
      loading: false,
      addressMessage: {},
      dataInfo: {},
      orderTotal: {
        subTotal: 0,
        shipping: 0,
        shippingDisc: 0
      },
      orderStatusOptions: [
        {label: 'Unpaid', value: 0},
        {label: 'Paid', value: 1},
        {label: 'Cancelled', value: 2},
        {label: 'Shipped', value: 3},
        {label: 'Partial Shipped', value: 4},
        {label: 'Received', value: 5},
        {label: 'Refund under review', value: 6},
        {label: 'Refunded', value: 7},
        {label: 'Declined on Refund', value: 8},
        {label: 'On Hold', value: 31},
        {label: 'Progressing', value: 10},
        {label: 'Partial refund', value: 9},
        {label: 'Failed', value: 11},
        {label: 'Returning', value: 13},
        {label: 'Return completed', value: 23},
        {label: 'Complete partially', value: 24},
        {label: 'Tranding closed', value: 99},
        {label: 'Packaging', value: 40},
        {label: 'Partial Delivered', value: 52},
        {label: 'Delivered', value: 53},
        {label: 'Partial Received', value: 54}
      ]
    }
  },
  created() {
    getAction('/sp/suppliers/categorys').then(res => {
      if (res.code === 200) {
        this.categoryList = res.result
      }
    })
    this.batchNo = this.$route.query.orderId
    if (this.$ls.get('userInfo').userSource === 6) {
      this.isDropShipping = true
    }
    this.loadOrderDetails()
  },
  methods: {
    loadOrderDetails() {
      this.loading = true
      getAction(`order/api/v0.2/batch-orders/${this.batchNo}`).then(response => {
        if (response.success) {
          this.dataInfo = response['result']
          if (this.isDropShipping && this.dataInfo.batchInfoDetail.thirdOrderId) {
            this.dsOrder = `Ds Order # ${this.dataInfo.batchInfoDetail.thirdOrderId}`
          }
          this.dataInfo['batchInfoOrderList'].forEach(obj => {
            if (obj['tsStoreOrderInfo']['freightDiscounted'] && Number(obj['tsStoreOrderInfo']['freightDiscounted']) > 0) {
              this.orderTotal['shippingDisc'] += Number(obj['tsStoreOrderInfo']['freightDiscounted'])
            }
            if (obj['tsStoreOrderInfo']['totalFreightBefore'] && Number(obj['tsStoreOrderInfo']['totalFreightBefore']) > 0) {
              // this.orderTotal['shipping'] += Number(obj['tsStoreOrderInfo']['totalFreightBefore'])
            }
            this.orderTotal['subTotal'] += (Number(obj['tsStoreOrderInfo']['totalPriceBefore']) - Number(obj['tsStoreOrderInfo']['productDiscounted']) - Number(obj['tsStoreOrderInfo']['orderDiscounted']))
          })
          this.orderTotal['subTotal'] -= Number(this.dataInfo['batchInfoDetail']['couponPrice'])
        } else {
          this.$message.warning(response.message)
        }
        this.loading = false
      })
    },
    openAddress() {
      this.addressMessage = {
        addressId: '',
        type: 'ordeDetail',
        userId: this.userId
      }
      this.$refs.address.dialogVisible = true
    },
    handleViewInvoice() {
      this.$router.push({
        path: `procurement-orders-invoice?orderId=${this.dataInfo.batchInfoDetail.uid}&orderType=true`
      })
    },
    // TODO 有物流单号跳转去查单号，有签收图片展示图片
    handleTrackingInfo() {
      const orderNo = ''
      if (orderNo) {
        window.open(`https://www.dhl.com/hk-en/home/tracking/tracking-express.html?submit=1&tracking-id=${orderNo}`)
        return
      }
      const image = ''
      if (image) {
        this.images = [image]
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.show()
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-card__header {
  background: #F7F7F7;
}

.page_title {
  margin: 10px 30px 30px 0px !important;
}

.bold {
  font-weight: 700;
}

.border {
  height: 100px;
  width: 1px;
  border-right: 1px solid #cccccc;
}

.tracking-btn {
  height: 40px;
  background-color: #262b2f;
  border-color: #262b2f;
  min-width: 100px;
  border-radius: 0;
  color: #F7F7F7;
  margin-right: 10px;
}

.orange {
  color: #c3824b;
}

.gray {
  color: #5d5d5d
}

.order {
  width: 100%;
  font-size: 14px;
  font-family: Graphik;

  &-header {
    width: 100%;
    display: flex;
    align-items: center;
    white-space: nowrap;

    .address {
      display: flex;
      flex-direction: column;
      padding: 0 4% 0 4%;
    }

    &-item {
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 0 4% 0 4%;
      span {
        margin-bottom: 2px;
      }
    }
  }
  &-content {

    &-header {
      display: flex;
      justify-content: space-between;

    }

    &-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      border-bottom: 1px solid #E1E1E1;
      padding-bottom: 20px;
      margin-bottom: 20px;

      .img {
        width: 100px;
        height: 100px;
        border: 1px solid #E1E1E1;
      }

      .item-con {
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .item-bottom {
          margin-top: 10px;
          display: flex;
          flex-direction: row;

          &-item {
            height: 40px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-right: 40px;

          }
        }
      }
    }

    &-item:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }
  }

  &-bottom {
    margin-top: 20px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .bottom-right {
      width: 300px;

      &-block {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;

      }

      .item {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-top: 14px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/wholesale/procurement-orders-detail.vue